/**
 * ProductsCarousel.tsx — Renders a horizontal carousel of product cards fetched
 * from the CMS section's pre-processed product data.
 *
 * JSON trigger: `uiCompType.method: "renderProductsCarousel"`
 *
 * **Data flow:**
 *  1. CMS JSON `preprocess.method: "getProductDetails"` (in `getCms.tsx`) fetches
 *     product data and attaches it to `sectionData.items`.
 *  2. `ProductsCarousel` transforms `sectionData.items` using
 *     `prepareCardsForBuilderProductsGrid` (from `@/translator`).
 *  3. Result is passed to `CustCarousel` for rendering.
 *
 * **Key options:** `options.height`, `options.width` — card dimensions.
 *
 * **Delegates to:** `CustCarousel` → `CommonCarouselComponent`.
 *
 * **Style slots:** `uiCompType.styles` (outer container).
 */
import React, { useState } from "react";
import { SectionData, ComponentRenderProps, renderFunctions } from "./index";
//import generateProductCards from "'@/app/components/products/shop_product_cards";
import { prepareCardsForBuilderProductsGrid } from "@/translator";
import { getBrandPathEntry } from "./cmsUtils";
import { handleProductSelection } from "./shared";
import Title from "./Title";
import Product from "@/app/components/cms_renderer/Product";

interface ProductsCarouselProps {
    sectionData: SectionData;
    props: ComponentRenderProps;
}

const ProductsCarousel = ({ sectionData, props }: ProductsCarouselProps): JSX.Element | null => {
    const { vendorName, userInfo, favorites, setFavorites } = props;
    if (!sectionData.items || sectionData.items.length === 0) {
        return sectionData.title ? <Title sectionData={sectionData} props={props} /> : null;
    }

    /*     const items2 = generateProductCards(
            prepareCardsForBuilderProductsGrid(sectionData.items as any[], getBrandPathEntry(vendorName as string)),
            handleProductSelection,
            (sectionData.uiCompType?.options?.height || "320px"),
            sectionData.trackId ?? 'productsCarousel_',
            undefined,
            undefined,
            undefined,
            favorites,
            setFavorites,
            userInfo?.cId
        ); */

    const hidePricing = sectionData.uiCompType?.options?.hidePricing === true;
    const showLoginOverlay = sectionData.uiCompType?.options?.showLoginOverlay === true;

    const items = sectionData.items.map((item, index) => {
        return (
            <Product
                card={item as any}
                favorites={favorites}
                setFavorites={setFavorites}
                customerId={userInfo?.cId}
                onClick={(e, card) => handleProductSelection(e, card)}
                height={"320"}
                width={"320"}
                pageName={sectionData.pageName}
                hidePricing={hidePricing}
                showLoginOverlay={showLoginOverlay}
            />
        );
    });
    const CustCarouselComponent = renderFunctions.CustCarousel;
return <CustCarouselComponent sectionData={{ ...sectionData, items: items }} props={props} />;
    // return renderFunctions.CustCarousel({ ...sectionData, items2 }, props);


}

export default ProductsCarousel;
